const imageBase = 'https://unitdweb.unitdtechnologies.com/storage/uploads/'
export default imageBase
